// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__27vK4","left":"StickyBox_left__1h25H","right":"StickyBox_right__1LQJn"};